import { render, staticRenderFns } from "./productSingle.vue?vue&type=template&id=43cb0f61&"
import script from "./productSingle.vue?vue&type=script&lang=js&"
export * from "./productSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports